const setRadioUrl = () => {
  const radios = document.querySelectorAll('.form input[type="radio"]');

  radios.forEach(radio => {
    radio.addEventListener('change', (e) => {
      const url = e.currentTarget.dataset.url; // data-url を取得
      if(url) {
        window.location.href = url;
      }
    });
  });
};

export default setRadioUrl;
